var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___S2JRZW",
};

module.exports = exports;
